import { useMutation } from '@tanstack/react-query';
import { saveAs } from 'file-saver';
import { AxiosError } from 'axios';
import { useSnackbarNotification } from '@store/snackbarNotification';

export const useDownloadFile = ({
    fetcher,
    getFileName,
    successTitle = 'Sukses Download',
    errorTitle = 'Gagal Download',
    loadingTitle = 'Downloading',
}) => {
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    return useMutation({
        mutationFn: async (variables) => {
            const filename = getFileName(variables);
            const data = await fetcher(variables);
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blob, filename);

            return { filename };
        },

        onMutate: (variables) => {
            const filename = getFileName(variables);
            onChangeSnackbarNotification({
                title: loadingTitle,
                status: 'info',
                description: (
                    <>
                        Harap tunggu, sedang mendownload file <b>{filename}</b>
                    </>
                ),
                duration: 3,
            });
            return { filename };
        },

        onSuccess: ({ filename }) => {
            onChangeSnackbarNotification({
                status: 'success',
                title: successTitle,
                description: (
                    <>
                        Download <b>{filename}</b> berhasil
                    </>
                ),
                duration: 3,
            });
        },

        onError: async (error) => {
            let errorMessage = error.message || 'Terdapat kesalahan sistem, silahkan coba beberapa saat lagi.';

            if (error instanceof AxiosError && error.response?.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    errorMessage = json?.message ?? errorMessage;
                } catch {
                    // ignore parse error
                }
            }

            onChangeSnackbarNotification({
                status: 'error',
                title: errorTitle,
                description: errorMessage,
                duration: 3,
            });
        },
    });
};
